export const ViewGridTypeEnum = {
  READ_ONLY_VIEW: 0,
  SYSTEM_VIEW: 1,
  PRIVATE_VIEW: 2
} as const;

export type ViewGridType = (typeof ViewGridTypeEnum)[keyof typeof ViewGridTypeEnum];
